export function usePostMessage(){

  /**
   * 执行消息 通知父界面
   */
  const initPageMsg=function (){
    try{
      window.parent?.postMessage(
        { action: "loadDesComOver", namespace: "xm" },
        "*"
      );
      window.opener?.postMessage(
        { action: "loadDesComOver", namespace: "xm" },
        "*"
      );
    }catch (e){
      console.error(e,"----initPageMsg--")
    }
  }

  const closeTempMsg=function (){
    try{
      window.parent?.postMessage(
        { action: "loadTempShow", namespace: "xm" },
        "*"
      );
      window.opener?.postMessage(
        { action: "loadTempShow", namespace: "xm" },
        "*"
      );
    }catch (e){
      console.error(e,"----initPageMsg--")
    }
  }


  return {
    closeTempMsg,
    initPageMsg
  }
}
